// src/pages/dashboard/PlayerInsightsStatsPage.js
import React, { useState } from 'react';
import { Layout } from 'antd';
import { useLocation } from 'react-router-dom';
import DashboardNavBar from '../../components/dashboard/DashboardNavBar';
import PlayerInsightsStats from '../../components/dashboard/PlayerInsightsStats';

const { Content } = Layout;

const PlayerInsightsStatsPage = () => {
  const location = useLocation();
  const { game } = location.state; // Access the passed game data

  // State to manage the collapsed state of the navbar
  const [collapsed, setCollapsed] = useState(false);

  const handleToggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  return (
    <Layout style={{ height: '100vh' }}>
      {/* Pass collapsed state and toggle handler to the navbar */}
      <DashboardNavBar game={game} collapsed={collapsed} onToggle={handleToggleCollapsed} />

      <Layout
        style={{
          marginLeft: collapsed ? '80px' : '250px', // Adjust dynamically based on the collapsed state
          transition: 'margin-left 0.2s', // Smooth transition for collapsing
          paddingTop: '64px', // Offset for top navigation bar
          backgroundColor: '#fff', // Match content background
        }}
      >
        <Content
          style={{
            padding: '20px',
            background: '#fff',
          }}
        >
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <PlayerInsightsStats gameId={game.id} />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default PlayerInsightsStatsPage;
